<script lang="ts">
	import { resolve } from '$app/paths';
	import { resolveAny } from '$lib/shared/lib';
	import { goto } from '$app/navigation';
	import { fetchLogout } from '$lib/features/auth/api/auth';
	import type { User } from '$lib/shared/lib';
	import { pageTransitioning } from '$lib/shared/lib/stores';

	import { isOnboardingIncomplete, getNavigationState } from '$lib/app/guards';
	import { page } from '$app/state';
	interface Props {
		user: User | null;
	}

	let { user }: Props = $props();

	function logout() {
		fetchLogout(fetch).then((response) => {
			if (response.status == 200) {
				window.location.reload();
			}
		});
	}

	function navigateToAdmin() {
		if (!user) {
			return;
		}

		let toUrl: string;

		if (onboarded && user.streams && user.streams.length > 0) {
			toUrl = `/admin/${user.streams[0].tag}/panel`;
		} else {
			toUrl = '/onboard';
		}

		if (page.url.pathname === toUrl) {
			return;
		}

		pageTransitioning.set(true);

		setTimeout(() => {
			goto(resolveAny(toUrl));
		}, 0);
	}
	let navState = $derived(getNavigationState(user));
	let onboarded = $derived(!isOnboardingIncomplete(navState));
</script>

<!--
	Account-box popup body. 02-06 wires this into AvatarComponent's <Popup />
	slot in each layout consumer, so visibility is controlled by the Popup's
	`{#if open}` block. No outer wrapper needed.
-->
{#if user}
	<div
		class="min-w-48 rounded-lg border border-surface-300-700 bg-surface-100-900 p-2 font-medium shadow-xl"
	>
		<!-- Section 1: User Info -->
		<div class="flex items-center gap-3 border-b border-surface-300-700 p-4 pt-2">
			<img
				src={user.avatar}
				alt="avatar"
				class="h-10 w-10 flex-shrink-0 rounded-full border-2 border-surface-300-700 object-cover"
			/>
			<span class="truncate font-medium text-surface-950-50">{user.title}</span>
		</div>

		<!-- Section 2: Navigation Links -->
		<div class="border-b border-surface-300-700 py-2">
			<nav class="space-y-1">
				<a
					href={resolve('/account')}
					class="click flex items-center px-4 py-2 text-sm text-surface-800-200 transition-colors hover:preset-tonal-surface hover:text-primary-500"
				>
					My Supertip
				</a>

				<button
					onclick={navigateToAdmin}
					class="click flex w-full items-center px-4 py-2 text-left text-sm text-surface-800-200 transition-colors hover:preset-tonal-surface hover:text-primary-500"
				>
					{#if onboarded && (user.streams.length > 0 || user.superuser)}
						Creator Dashboard
					{:else}
						Sign up to Supertip
					{/if}
				</button>
			</nav>
		</div>

		<!-- Section 3: Sign Out -->
		<div class="py-2">
			<button
				onclick={logout}
				class="click w-full px-4 py-2 text-left text-sm text-surface-800-200 transition-colors hover:preset-tonal-surface hover:text-error-500"
			>
				Sign Out
			</button>
		</div>
	</div>
{/if}
